export default [
  'W2',
  'W2C',
  '1099Misc - Corrected',
  '1042S - Amended',
  '592B - Amended',
  'G2FP – Corrected',
  'T4',
  'T4A',
  'Releve 1',
  'T4ANR',
  'NR4',
];
